import React from 'react';
export const FloatingCTA = () => {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg py-3 px-4 z-50" data-id="element-108">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between" data-id="element-109">
        <div className="mb-3 md:mb-0" data-id="element-110">
          <p className="font-bold text-gray-800" data-id="element-111">
            Odzyskaj miłość męża - tylko dziś za 29,99 zł{' '}
            <span className="text-red-600" data-id="element-112">(zamiast 39,99 zł)</span>
          </p>
        </div>
        <a href="https://sklep.veiramode.com/products/od-frustracji-do-sily-psychologiczny-przewodnik-przez-kryzys-malzenski" className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 rounded-lg shadow transform transition-all hover:scale-105 inline-block" data-id="element-113">
  RATUJ MAŁŻEŃSTWO → ODBIERZ TERAZ
      </a>
      </div>
    </div>;
};